import React, { FCC, PropsWithChildren } from 'react'
import { useModalContext } from '@sketch/components'
import {
  Footer,
  Button,
  ModalStyled,
} from './MoveStorageItemModalLayout.styles'

export interface MoveStorageItemModalLayoutProps {}

export const MoveStorageItemModalLayout: FCC<
  MoveStorageItemModalLayoutProps
> = props => {
  const hideModal = useModalContext().hideModal

  const { children } = props

  return <ModalStyled onCancel={hideModal}>{children}</ModalStyled>
}

export interface MoveStorageItemModalFooterProps extends PropsWithChildren<{}> {
  disabled?: boolean
  loading?: boolean
  onClick?: () => void
  dimmed?: boolean
  actionLabel: string
  /**
   * Whether to show ellipsis in the button text
   * @default false
   */
  indicateNextStep?: boolean
}
export const MoveStorageItemModalFooter: FCC<
  MoveStorageItemModalFooterProps
> = props => {
  const hideModal = useModalContext().hideModal
  const {
    disabled,
    loading,
    onClick,
    children,
    dimmed,
    indicateNextStep,
    actionLabel,
  } = props

  return (
    <Footer dimmed={dimmed}>
      {children}
      <Button onClick={hideModal}>Cancel</Button>
      <Button
        variant="primary"
        disabled={disabled}
        loading={loading}
        onClick={onClick}
      >
        {actionLabel}
        {disabled || indicateNextStep ? '…' : ''}
      </Button>
    </Footer>
  )
}
